import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ContentSection from './components/ContentSection';
import TrustSection from './components/TrustSection';
import ArticleCards from './components/ArticleCards';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

export default function Home() {
  return (
    <main>
      <Navbar />
      <HeroSection />
      <CategorySection />
      <ContentSection />
      <TrustSection />
      <ArticleCards />
      <FAQSection />
      <CTASection />
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'CSSSpreadsheet',
            url: siteUrl,
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </main>
  );
}